import { AppState } from 'src/store';
import _, { Dictionary } from 'lodash';
import { GridEntity } from '../query/types';


export const GetLoginStatus = (state: AppState) => {
    return state.global.login
}

export const GetBaseUrl = (state: AppState) => {
    return state.global.options.baseUrl
}

export const GetToken = (state: AppState) => {
    return state.global.login.token
}

export const GetLocation = (state: AppState) => state.router.location

export const GetUser = (state: AppState) => state.global.login.token?.user;

export const GetGrids = (state: AppState) => state.global.grids.grids;

export const GetGrid: (gridId: string) => (state: AppState) => GridEntity = (gridId) => (state) => {
    const { grids } = state.global.grids;
    const flattened: Dictionary<GridEntity> = _.keys(grids).reduce((acc: any, resource) => {
        const gridsByIds = grids[resource];
        _.keys(gridsByIds).forEach(id => { acc[id] = gridsByIds[id] })
        return acc;
    }, {});
    return flattened[gridId];
}
